module.exports = __webpack_public_path__ + "media/images/ac_templates/201/mlgrn-b42dac747e1b3dda3e0d0a009d70b69a.jpg";